import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function HelpText({ children, sx, ...props }) {
    return (
        <Box sx={{ display: 'flex', gap: 1, mb: 2, ...sx }}>
            <InfoOutlinedIcon sx={{ fontSize: '1.25rem', color: 'text.secondary', mt: '1px', flexShrink: 0 }} />
            <Typography
                variant="body2"
                color="text.secondary"
                {...props}
            >
                {children}
            </Typography>
        </Box>
    );
}
